import _regeneratorRuntime from "@babel/runtime/regenerator";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import Vue from 'vue';
import stores from '../../../Scripts/stores';

var Vuex = function Vuex() {
  return import(
  /* webpackChunkName: 'vuex' */
  'vuex');
};

export default {
  load: function load(modules, name, id, config) {
    var module = modules[name];
    id = "#" + id;

    if (!module) {
      console.log("***Warning - Unable to create an instance of: [".concat(name, "]"));
      return;
    }

    var initializeVueModule =
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(module, id, config) {
        var storeList, storeIndex, vuex, vueModule;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!module.name) {
                  module.name = name;
                } // only load vuex for modules using a store


                storeList = Object.keys(stores) || [];
                storeIndex = storeList.findIndex(function (s) {
                  return s.indexOf(name) !== -1;
                });

                if (!(storeIndex !== -1)) {
                  _context.next = 9;
                  break;
                }

                _context.next = 6;
                return Vuex();

              case 6:
                vuex = _context.sent;
                Vue.use(vuex);
                module.store = new vuex.Store({
                  modules: _objectSpread({}, stores)
                });

              case 9:
                vueModule = new Vue(module).$mount(id);

                if (vueModule.init) {
                  vueModule.init(config);
                }

                return _context.abrupt("return", vueModule);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function initializeVueModule(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }();

    var isDynamicImport = typeof module === 'function'; // resolve dynamic import, when applicable.  

    if (isDynamicImport) {
      return module().then(function (m) {
        return initializeVueModule(m.default, id, config);
      });
    } // otherwise, use static import.


    return initializeVueModule(module, id, config);
  }
};